import { styled } from "@mui/material/styles";
import { Stack } from "@mui/material";
import { HubCardStack } from "../../components";

export const StyledContainerStack = styled(Stack)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "minmax(40%, 700px) 1fr",
  height: "calc(100vh - 91px)",
  width: "100%",
  position: "relative",
}));

export const StyleTableCardStack = styled(HubCardStack)(({ theme }) => ({
  border: "none",
  height: "100%",
  overflow: "hidden",
  ".HubOrdersTableSwitch-root": {
    padding: 0,
    border: "none",
  },
}));
